import { API_BASE_URL } from "../config/api";
import { complementMDM, fullComplementMDM } from "../utils/ConstantsURL";

export const getComplementMDM = async (
  id_documento,
  isPreview = process.env.REACT_APP_IS_PREVIEW === 'true'
) => {
  const url = `${API_BASE_URL}${complementMDM(id_documento, isPreview)}`;

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`HTTP ${response.status} al llamar: ${url}`);
  }

  const result = await response.json();

  return result?.data || null;
};

export const getFullComplementMDM = async () => {
  const url = `${API_BASE_URL}${fullComplementMDM()}`;

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`HTTP ${response.status} al llamar: ${url}`);
  }

  const result = await response.json();

  return result || null;
};